import { ProfilerProduct } from "../../../../types/ProfilerProduct";
import { getAssetPath } from "../../../../../../lib/assetPath";
import { useTranslation } from "../../../../../../lib/i18n";

type BeautyProfilerSecondaryFragrancesProps = {
  topSecondaryFragrances: {
    secondFetiche: ProfilerProduct | null;
    topLoubiworld: ProfilerProduct | null;
  };
};

export const BeautyProfilerSecondaryFragrances =
  ({ topSecondaryFragrances }: BeautyProfilerSecondaryFragrancesProps) => {
    const { t } = useTranslation();

    return (
      <>
        <div className="text-[#050505] text-center font-garamond-italic text-[22px] font-normal italic">
          {t('results.beauty.moreScents')}
        </div>
        <div className="flex items-start gap-4 self-stretch">
          <FragranceCard
            name={topSecondaryFragrances.secondFetiche?.label}
            imagePath={`/beauty-profiler/secondary-fragrances/${topSecondaryFragrances.secondFetiche?.id}.avif`}
          />
          <FragranceCard
            name={topSecondaryFragrances.topLoubiworld?.label}
            imagePath={`/beauty-profiler/secondary-fragrances/${topSecondaryFragrances.topLoubiworld?.id}.avif`}
          />
        </div>
      </>
    );
  };



export type FragranceCardProps = {
    name: string | undefined;
    imagePath: string | undefined;
  };
  
  export const FragranceCard = ({ name, imagePath }: FragranceCardProps) => {
    return (
      <div className="flex flex-col justify-between items-start flex-1 self-stretch p-4 rounded-lg bg-gradient-to-b from-[#FAF5F1] to-[#F5EEEB] gap-6">
        <h3 className="text-[#CE0A2C] font-minion text-[16px] font-normal">
          {name}
        </h3>
        <img src={imagePath ? getAssetPath(imagePath) : imagePath} alt={imagePath} />
      </div>
    );
  };
  